// this file is generated by update_shopify_store_data.py at 2026-02-23 20:25:47.824743
var courses = [
    {
        "course_id": "90DD16F2-4B86-EE11-9987-005056A725AD",
        "course_version": 1,
        "name": "ANA: APRN Pharmacology Today: Safe Medication Use in Older Adults with Cardiovascular Disease",
        "course_type": 1,
        "author_information": "",
        "description": "Overview\r\nThis APRN Pharmacology Today course provides an introduction to the pitfalls of medication use in older adults with cardiovascular disease, including pharmacologic changes and potential inappropriate medication use. The course focuses on current evidence-based clinical practice guidelines, standards of care, and treatment options to safely prescribe and manage chronic cardiovascular disease in older adult patients.",
        "learning_objectives_html": "At the conclusion, participants should be able to:\r\n<ul>\r\n    <li>Review current literature and guideline recommendations for the safe use of medications in older adults</li>\r\n    <li>Compare and contrast the available pharmacologic treatments that ensure safe use of medications in older adults</li>\r\n    <li>Formulate a treatment and monitoring plan for safe use of medications in older adults using case studies</li>\r\n    <li>And much more!</li>\r\n</ul>",
        "course_outline_html": "",
        "credit_info": "-",
        "categories": [
            {
                "course_category_id": "18DBACB6-C884-EE11-998F-005056A7C6AF",
                "course_category_name": "ANA - American Nurses Association",
                "is_system_course_category": null
            },
            {
                "course_category_id": "9D089F81-80D3-EF11-9991-005056A78EAA",
                "course_category_name": "ANA - ANA APRN Pharmacology Bundle - Courses",
                "is_system_course_category": null
            },
            {
                "course_category_id": "5EC7EE02-0083-EE11-9986-005056A740BF",
                "course_category_name": "ANA - American Nurses Association",
                "is_system_course_category": null
            },
            {
                "course_category_id": "41A45D8A-264F-DB11-9011-000423ACEF71",
                "course_category_name": "Pharmacology",
                "is_system_course_category": null
            },
            {
                "course_category_id": "1F4B1A8B-1EC9-E511-8771-005056B104B1",
                "course_category_name": "Nurse Midwife",
                "is_system_course_category": null
            },
            {
                "course_category_id": "C98E2D7E-1EC9-E511-8771-005056B104B1",
                "course_category_name": "Nurse Anesthetist",
                "is_system_course_category": null
            },
            {
                "course_category_id": "8FAC2CA7-C884-EE11-998F-005056A7C6AF",
                "course_category_name": "ANA - American Nurses Association",
                "is_system_course_category": null
            },
            {
                "course_category_id": "7C6F7677-8F9E-E511-9627-005056B1456A",
                "course_category_name": "Nurse Practitioner",
                "is_system_course_category": null
            }
        ],
        "ce_accreditation": {
            "accrediting_body_name": "ANCC",
            "accreditation_statement": "American Nurses Association is accredited with distinction as a provider of nursing continuing professional development by the American Nurses Credentialing Center's Commission on Accreditation.",
            "course_level_accreditation_statement": "",
            "credit_display_name": "ANCC CNE Credit",
            "credit_units": 3.25,
            "credit_unit_display_name": "ANCC Contact\r\nHour(s)"
        },
        "sub_courses": []
    }
];